import { render } from "./AnalogWatch.vue?vue&type=template&id=38cf3e9b&scoped=true"
import script from "./AnalogWatch.vue?vue&type=script&lang=js"
export * from "./AnalogWatch.vue?vue&type=script&lang=js"

import "./AnalogWatch.vue?vue&type=style&index=0&id=38cf3e9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cf3e9b"]])

export default __exports__